<template>
    <div :style="margin_left !== undefined ? margin_left : ''">
        <div class="row m-0">
            <div class="col-lg-12 col-md-12 pt-1">
                <div class="mb-1">
                    <div id="infinite_scroll_list" class="d-inline-block mr-2">
                        <div class="dropdown">
                            <button class="modal__buttons__item dropdown-toggle w-auto px-3 ml-0" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Fields
                            </button>
                            <div class="dropdown-menu dropdown-no-close pt-0" aria-labelledby="dropdownMenuButton" style="max-height: 30vh; overflow-y: auto;  width: 100%">
                                <div class="mt-1" style="background-color: white; position: sticky; top: 0; z-index: 1;">
                                    <div class="input-field my-3 sticky-top" style="width: 100%;  background-color: white;">
                                        <input type="text" placeholder="Search" id="input-search-dropdown" class="validate inputSearchNoIcon" v-model="search_field" ref="input_search_dropdown">
                                    </div>
                                </div>
                                <div class="mt-2">
                                    <span data-v-25f661d4="" class="custom-control custom-checkbox w-100">
                                        <input data-v-25f661d4="" :id="`check_all_field_show`" type="checkbox" class="custom-control-input" :checked="select_all_fields" @change="selectAllFields()">
                                        <label data-v-25f661d4="" :for="`check_all_field_show`" class="custom-control-label reports__show-hide__label ml-2"></label>
                                    </span>
                                </div>
                                <div v-for="(item, i) in display_select_headers" :key="i" class="mt-2">
                                    <span data-v-25f661d4="" class="custom-control custom-checkbox w-100">
                                        <input data-v-25f661d4="" :id="`${item.text}${name}field_show`" type="checkbox" class="custom-control-input" v-model="item.show">
                                        <label data-v-25f661d4="" :for="`${item.text}${name}field_show`" class="custom-control-label reports__show-hide__label ml-2">{{ item.text }}</label>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="infinite_scroll_list" class="d-inline-block" v-if="totals">
                        <div class="dropdown">
                            <button class="modal__buttons__item dropdown-toggle w-auto px-3 ml-0" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Totals
                            </button>
                            <div class="dropdown-menu dropdown-no-close pt-0" aria-labelledby="dropdownMenuButton" style="max-height: 30vh; overflow-y: auto;" ref="rooms_infinite_loader">
                                <div class="mt-1" style="background-color: white; position: sticky; top: 0; z-index: 1;">
                                    <div class="input-field my-3 sticky-top" style="width: 100%;  background-color: white;">
                                        <input type="text" placeholder="Search" id="input-search-dropdown" class="validate inputSearchNoIcon" v-model="search_total" ref="input_search_dropdown">
                                    </div>
                                </div>
                                <div class="mt-2">
                                    <span data-v-25f661d4="" class="custom-control custom-checkbox w-100">
                                        <input data-v-25f661d4="" :id="`check_all_total_show`" type="checkbox" class="custom-control-input" :checked="select_all_totals" @change="selectAllTotals()">
                                        <label data-v-25f661d4="" :for="`check_all_total_show`" class="custom-control-label reports__show-hide__label ml-2"></label>
                                    </span>
                                </div>
                                <div v-for="(total_section, i) in display_select_totals" :key="i" class="mt-2">
                                    <span data-v-25f661d4="" class="custom-control custom-checkbox w-100 mb-3" v-for="(item, index) in total_section" :key="index">
                                        <input data-v-25f661d4="" :id="`${item.text}${name}total_show`" type="checkbox" class="custom-control-input" v-model="item.show">
                                        <label data-v-25f661d4="" :for="`${item.text}${name}total_show`" class="custom-control-label reports__show-hide__label ml-2">{{ item.text }}</label>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="table-responsive table-fix-head horizontal-scroll-reports" :style="size ? `max-height: ${size}rem`: `max-height: 35rem`">
                    <table class="table">

                        <thead>
                            <draggable tag="tr" v-model="select_headers" group="headers" @start="drag=true" @end="drag=false" draggable=".header-item">

                                <template v-if="checkable && select_headers.length > 0">
                                    <th slot="header" scope="col" style="border-top: none;">
                                        <span class="custom-control custom-checkbox">
                                            <input :id="`theadcheck${name}`" v-model="select_all" type="checkbox" class="custom-control-input" @change="selectAll()"/>
                                            <label :for="`theadcheck${name}`" class="custom-control-label ml-2"/>
                                        </span>
                                    </th>
                                </template>

                                <template v-if="autoincrement">
                                    <th scope="col" class="header-item" v-html="'#'"/>
                                </template>

                                <template v-if="historiable">
                                    <th scope="col" class="header-item" v-html="'History'"/>
                                </template>

                                <template v-if="updateable !== undefined && updateable">
                                    <th scope="col" class="header-item" v-html="detail_text ? detail_text : 'Detail'"/>
                                        <!-- <span style="margin-left: 5px;">
                                            <img :src="`/assets/img/svg/update_entry.svg`" style="width:15px;" alt="Update Entry Icon"/>
                                        </span>
                                    </th> -->
                                </template>

                                <template v-if="headers">
                                    <th v-for="(header, i) in select_headers" :key="i" scope="col" class="header-item" :class="header.class ? header.class: ''" :style="`width:${header.width ? header.width : 'auto'}`" v-show="header && header.show == true">
                                        {{ header.text }}
                                        <span style="margin-left:15px;">
                                            <img :src="sortable ? `/assets/img/svg/sort-items-reverse.svg` : `/assets/img/svg/sort-items.svg`" class="iconHistory" style="width:15px;" alt="Sort Icon" @click="liveSorting(header.value)"/>
                                        </span>
                                    </th>
                                </template>

                            </draggable>
                        </thead>

                        <tbody>
                            <template v-if="headers.length && items.length && select_headers.length">
                                <tr v-for="(item, i) in display_items" :key="i">

                                    <template v-if="checkable">
                                        <td scope="col">
                                            <span class="custom-control custom-checkbox">
                                                <input :id="`checkAll${i}${name}`" type="checkbox" class="custom-control-input" v-model="item.checked"/>
                                                <label :for="`checkAll${i}${name}`" class="custom-control-label ml-2"/>
                                            </span>
                                        </td>
                                    </template>

                                    <template v-if="autoincrement">
                                        <td scope="col" v-html="i + 1" />
                                    </template>

                                    <template v-if="historiable">
                                        <td scope="col">
                                        <img src="/assets/img/svg/history.svg" class="iconHistory" alt="History" @click="history(item.id, item.name || item.description)">
                                        </td>
                                    </template>


                                    <template v-if="updateable !== undefined && updateable">
                                        <td scope="col">
                                            <a 
                                                class="bold-text"
                                                style="color: #039be5; text-decoration: none;"
                                                @click="emitToUpdate(item.id)"
                                            >
                                                <span style="margin-left: 5px;">
                                                    <img :src="`/assets/img/svg/update_entry.svg`" style="width:15px;" alt="Update Entry Icon"/>
                                                </span>
                                            </a>
                                        </td>
                                    </template>

                                    <td v-for="(header, j) in select_headers" :key="j" scope="col" v-show="header && header.show == true">
                                        <template v-if="header.type && header.type == 'link'">
                                            <a 
                                                v-if="header.event !== undefined && header.event"
                                                class="bold-text"
                                                :href="`#`"
                                                :class="{ 'supervisor-text-color': item.child }"
                                                v-html="item[header.value]"
                                                @click="emitToParent(item.id)"
                                            />

                                            <a 
                                                v-else
                                                class="bold-text"
                                                :class="{ 'supervisor-text-color': item.child }"
                                                :href="`${link}${item.id}`"
                                                v-html="item[header.value]"
                                            />

                                            <span style="margin-left: 5px;" v-if="!item.default_description && header.with_icon !== undefined && header.with_icon">
                                                <img :src="header.src_icon" style="width:15px;" alt="CustomDescription"/>
                                            </span>
                                        </template>

                                        <template v-else-if="header.type && header.type == 'linkExt'">
                                            <a 
                                                class="bold-text"
                                                :href="linkExt !== undefined ? `${linkExt}${item.id}` : '#'"
                                                v-html="item[header.value]"
                                            />
                                        </template>

                                        <!-- <template v-if="header.type_advanced !== undefined && header.type_advanced">

                                            <a 
                                                class="bold-text"
                                                :class="{ 'supervisor-text-color': item.child }"
                                                :href="`${link}${item.id}`"
                                                v-html="item[header.value]"
                                                @click="header.event !== undefined && header.event ? emitToParentAdvanced(item.id) : null"
                                            />

                                            <span style="margin-left: 5px;" v-if="!item.default_description && header.with_icon !== undefined && header.with_icon">
                                                <img :src="header.src_icon" style="width:15px;" alt="CustomDescription"/>
                                            </span>

                                        </template> -->

                                        <template v-else-if="header.type && header.type == 'number'">
                                            {{ format_number(item[header.value]) }}
                                        </template>

                                        <template v-else-if="header.type && header.type == 'percentage'">
                                            {{(item[header.value]) ? `${item[header.value]}%` : ''}} 
                                        </template>

                                        <template v-else-if="header.type && header.type == 'us-number'">
                                            {{ Number(item[header.value]).toLocaleString('en-US') }}
                                        </template>

                                        <template v-else-if="header.type && header.type == 'boolean'">
                                            {{ format_boolean(item[header.value]) }}
                                        </template>

                                        <template v-else-if="header.type && header.type == 'boolean_complete'">
                                            <p v-if="item[header.value]" v-html="'Completed'" style="color:#28a745; background-color: transparent; text-decoration: none; cursor: default; font-weight:bold; margin-bottom:0px;" />
                                            <p v-else v-html="'Incomplete'" style="color:#E1331A; background-color: transparent; text-decoration: none; cursor: default; margin-bottom:0px;" />
                                        </template>

                                        <template v-else-if="header.type && header.type == 'date'">
                                            {{ format_date(item[header.value]) }}
                                        </template>

                                        <template v-else-if="header.type && header.type == 'tasks'">
                                            <p class="font-weight-bold" :class="header.class ? header.class: ''">
                                                {{ arrayJoining(item[header.value]) }}
                                            </p>
                                        </template>

                                        <template v-else-if="header.type && header.type == 'array'">
                                            <p class="font-weight-bold" :class="header.class ? header.class: ''">
                                                {{ arrayJoining(item[header.value]) }}
                                            </p>
                                        </template>

                                        <template v-else-if="header.type && header.type == 'supervisor'">
                                            <p  v-if="item[header.value]" style="color:#26a69a;" v-html="`Supervisor`"/>
                                            <p  v-else v-html="`Not supervisor`"/>
                                        </template>

                                        <template v-else-if="header.type && header.type == 'role'">
                                            <p  v-if="item[header.value] == 'Organization Administrator' || item[header.value] == 'Digital Solutions Administrator'" style="color:#0063B0;" v-html="`${item[header.value]}`"/>
                                            <p  v-else-if="item[header.value] == 'Supervisor'" style="color:#26a69a;" v-html="`${item[header.value]}`"/>
                                            <p  v-else-if="item[header.value] == 'Employee'" style="color:#26a69a;" v-html="`${item[header.value]}`"/>
                                        </template>

                                        <template v-else-if="header.type && header.type == 'full_name'">
                                            <a class="bold-text" :href="`${link}${item.id}`" v-html="`${item.first_name} ${item.last_name}`"/>
                                        </template>

                                        <template v-else-if="header.type && header.type == 'hours'">
                                            {{ item[header.value] }} hrs
                                        </template>

                                        <template v-else-if="header.type && header.type == 'total_minutes'">
                                            {{ minutesBetweenHours(item.start_time, item.end_time) }}
                                        </template>

                                        <template v-else-if="header.type && header.type == 'text_bold'">
                                            <p class="font-weight-bold" v-html="item[header.value]" />
                                        </template>

                                        <template v-else-if="header.type && header.type == 'copy' && item[header.value]">
                                            <input v-show="false" v-model="item[header.value]" />
                                            <button type="button" class="btn-sm btn-light" @click="copyText(item[header.value])"><i class="fa fa-copy"></i></button>
                                        </template>

                                        <template v-else-if="header.type && header.type == 'link_action'">
                                            <a 
                                                class="bold-text"
                                                :href="'#'"
                                                @click="$emit('emitLinkAction', i)"
                                                v-html="header.value"
                                            />
                                        </template>

                                        <template v-else-if="header.type && header.type == 'text_link_action'">
                                            <a 
                                                class="bold-text"
                                                :href="'JavaScript:void(0);'"
                                                @click="$emit('emitAction', {index: i, header: `${header.value}_record`})"
                                                v-html="item[header.value]"
                                            />
                                        </template>
                                        

                                        <template v-else-if="header.type && header.type == 'link_action_with_href'">
                                            <a 
                                                class="bold-text"
                                                :href="`${link_action_href}${item.id}`"
                                                v-html="header.value"
                                            />
                                        </template>

                                        <template v-else-if="header.type && header.type == 'input'">
                                            <input 
                                                    :style="header.style"
                                                    :type="'number'" 
                                                    :max="'1000000000'" 
                                                    v-model="item[header.value]" 
                                                    :class="'input__fortables'"
                                                    @change="$emit('live_edition', {i, item})"
                                                />
                                        </template>

                                        <template v-else>
                                            {{ item[header.value] }}
                                        </template>

                                    </td>
                                </tr>
                            </template>
                        </tbody>
                        <tfoot>
                            <tr v-for="(total, i) in totals" :key="i" style="border-bottom: unset;"> 
                                <td v-if="checkable && headers.length > 0"/>
                                <td v-if="historiable && headers.length > 0"/>
                                <td v-if="updateable && headers.length > 0"/>
                                <td v-for="(header, j) in select_headers" :key="j" v-show="header &&  header.show === true">
                                    <template v-if="total[header.value] && total[header.value].show">
                                        <template v-if="total[header.value].type == 'text_link_action'"> 
                                            <a 
                                                class="bold-text"
                                                :href="'JavaScript:void(0);'"
                                                @click="$emit('emitAction', {index: -1, header: header.value})"
                                                v-html="total[header.value].value"
                                            />
                                        </template>
                                        <template v-else-if="total[header.value].type == 'percentage_value'"> 
                                            <b>{{(total[header.value]) ? `${total[header.value].value}%` : ''}}</b>
                                        </template>
                                        <template v-else> 
                                            <b>{{(total[header.value]) ? total[header.value].value : ''}}</b>
                                        </template>
                                    </template>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>

                <table v-if="select_headers.length > 0 && !not_show_footer" class="table table-md">
                    <tfoot>
                        <tr>
                            <th  class="float-right tfoot" scope="col" v-html="search === '' ? `Total Items: ${items.length}` : `Search displaying ${display_items.length} of ${items.length} items`"/>
                            <template v-if="array_options_table">
                                <th v-for="(item, i) in array_options_table" :key="i" class="float-right tfoot" scope="col" v-html="`${item.text}: ${item.type == 'number' ? format_number(item.value) : item.value}`" style="margin-right: 1rem"/>
                            </template>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</template>

<script>

import _                        from    "underscore"
import draggable                from    "vuedraggable"

export default {

    name: 'DinamicTable',

    props: [
        'items',
        'headers',
        'search',
        'link',
        'linkExt',
        'checkable',
        'selectable_columns',
        'margin_left',
        'historiable',
        'name',
        'rooms',
        'size',
        'updateable',
        'autoincrement',
        'array_options_table',
        'detail_text',
        'not_show_footer',
        'link_action_href',
        'totals'
    ],

    components: {
        draggable,
    },

    data()
    {
        return {
            select_all: false,
            select_headers: [],
            sortable: false,
            view_by_fields: true,
            close_show_hide: false,
            search_field: '',
            search_total: '',
            select_all_fields: false,
            select_all_totals: false,
        }
    },

    methods:
    {
        liveSorting(header_value) {
  if (this.sortable) {
    this.items.sort((item, item2) => {
      const value1 = item[header_value] != null ? item[header_value].toString() : '';
      const value2 = item2[header_value] != null ? item2[header_value].toString() : '';
      
      // Check if the values are numeric
      const isNumeric = (value) => !isNaN(parseFloat(value)) && isFinite(value);

      // Check if both values are numeric
      if (isNumeric(value1) && isNumeric(value2)) {
        return parseFloat(value1) - parseFloat(value2);
      }

      // Compare non-numeric values using localeCompare
      return value1.localeCompare(value2);
    });
  } else {
    this.items.sort((item, item2) => {
      const value1 = item[header_value] != null ? item[header_value].toString() : '';
      const value2 = item2[header_value] != null ? item2[header_value].toString() : '';

      // Check if the values are numeric
      const isNumeric = (value) => !isNaN(parseFloat(value)) && isFinite(value);

      // Check if both values are numeric
      if (isNumeric(value1) && isNumeric(value2)) {
        return parseFloat(value2) - parseFloat(value1);
      }

      // Compare non-numeric values using localeCompare
      return value2.localeCompare(value1);
    });
  }

  this.sortable = !this.sortable;
}
,

        async copyText(text)
        {
            await navigator.clipboard.writeText(text)
            this.notyfMesg('Copied to the clipboard')
        },
        emitToUpdate(id)
        {
            const index = this.items.findIndex(item => item.id === id)
            this.$emit('emitToUpdate', index)
        },

        emitToParent(id)
        {
            const index = this.items.findIndex(item => item.id === id)
            this.$emit('emitToParent', index)
        },

        selectAll()
        {
            this.display_items.map(item => item.checked = this.select_all)
        },

        format_number(value)
        {
            return value ? value.toLocaleString('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) : '';
        },

        format_boolean(value)
        {
            return value ? 'Yes' : 'No'
        },

        format_date(value)
        {
            if(value)
            {
                value = new Date(value)
                return `${value.toISOString().split('T')[0]} at ${value.toLocaleTimeString()}`
            }
            else 
            {
                return value
            }  
        },

        arrayJoining(array)
        {
            if (!Array.isArray(array)) 
            {
                return array
            }

            const names = array.map(item => 
            {
                if (typeof item === 'object' && item !== null && 'name' in item) {
                    return item.name;
                } 
                else 
                {
                    throw new Error("Invalid item in array: missing 'name' property");
                }
            });

            return names.join(", ");
        },

        reset_select()
        {
            this.select_all = false
            this.selectAll()
        },

        refresh_headers()
        {
            this.headers.forEach(item => {
                this.$set(item, 'show', true);
            });

            this.select_headers = this.headers;

        },

        history(id, title)
        {
            this.$emit('history', { id, title })
        },

        selectAllFields()
        {
            this.select_all_fields = !this.select_all_fields
            this.display_select_headers.forEach(item => {
                this.$set(item, 'show', this.select_all_fields);
            });

            
        },

        selectAllTotals()
        {
            this.select_all_totals = !this.select_all_totals
            this.display_select_totals.forEach(total => {
                Object.keys(total).forEach(key => {
                    this.$set(total[key], 'show', this.select_all_totals);
                });
            });

            if (!this.search_total) 
            {
                return this.totals;
            }

            const searchQuery = this.search_total.toLowerCase();
             this.totals.map(total => {
                const filteredTotal = {};

                Object.entries(total).forEach(([key, item]) => {
                    const {text} = item;

                    if (text && text.toLowerCase().includes(searchQuery)) {
                        total[key].show = this.select_all_totals;
                    }
                });
                return filteredTotal;
            });
        }
    },

    watch: {
        display_items(val)
        {
            if(val && this.rooms)
            {
                if(val.length !== this.items.length)
                {
                    localStorage.setItem('rooms', JSON.stringify(val.map(value => value.id )))
                }
            }
        },

        select_headers: {
            handler(val)
            {
                if(val.length)
                {
                    let checked_items = 0;
                    checked_items = val.filter(item => item.show).length

                    if(checked_items === val.length)
                    {
                        this.select_all_fields = true
                    }
                    else
                    {
                        this.select_all_fields = false
                    }
                }
            },
            deep: true
        },

        totals: {
            handler(val)
            {
                if(val.length)
                {
                    let all_items = 0;
                    let checked_items = 0;
                    this.totals.forEach(total => 
                    {
                        const keys = Object.keys(total)
                        all_items += keys.length
                        
                        checked_items += keys.filter(key => {
                           return total[key]['show'] === true
                        }).length
                    });

                    if(all_items === checked_items)
                    {
                        this.select_all_totals = true
                    }
                    else
                    {
                        this.select_all_totals = false
                    }
                }
            },
            deep: true
        }
    },

    computed:
    {
        display_items()
        {
            const filters_items = [];
            if(this.search)
            {
                this.headers.forEach(header =>
                { 
                    filters_items.push( ... this.items.filter(item =>
                    {
                        return String(item[header.value]).toLowerCase().includes(this.search.toLowerCase())
                    }))
                });
            }
            return this.search ? _.uniq(filters_items, item => item.id ) : this.items; 
        },

        label_headers()
        {
            return this.select_headers.length ? '' : 'Columns'
        },

        display_select_headers() 
        {
            if(this.search_field)
            {
                return this.select_headers.filter(item =>  item && item.text.toLowerCase().includes(this.search_field.toLowerCase()));
            }
            else
            {
                return this.select_headers
            }
        },

        display_select_totals() 
        {
            if (!this.search_total) 
            {
                return this.totals;
            }

            const searchQuery = this.search_total.toLowerCase();
            return this.totals.map(total => {
                const filteredTotal = {};

                Object.entries(total).forEach(([key, item]) => {
                    const { type, text, value, show } = item;

                    if (text && text.toLowerCase().includes(searchQuery)) {
                        filteredTotal[key] = { type, text, value, show };
                    }
                });

                return filteredTotal;
            });
        }
    },

    mounted()
    {
        this.refresh_headers()
    }, 
}
</script>

<style scoped>

    .tfoot {
        border: 0;
        margin-right: 3rem;
    }

    .multiselect__tag {
        background: blue !important;
    }

</style>
